import React, { useState, useEffect, Fragment } from "react";
import { Button } from "primereact/button";
import FormDropdown from "../../component/dropdown/formDropdown";
import ErrorMessage from "../../component/errorMessage/errorMsg";
import Forminputtext from "../../component/inputtext/forminputtext";
import { Checkbox } from "primereact/checkbox";
import PopUpScreen from "../../component/popUpScreen/popUpScreen";
import { useDispatch, useSelector } from "react-redux";
import { CLEAR_ALL_ERROR_MESSAGE, SET_ERROR_MESSAGE, SET_FORM_VALUE } from "../../redux/alert/alert.type";
import { emptycheckFields } from "../../validator/pageValidation";
import { emptyErrorCheck } from "../../helpers/validation/emptyValidation";
import { EditAlert, submitAlert } from "../../redux/alert/alert.action";
import { validateEmail } from "../../helper";

function AddNewAlert({ dataAssetId, onHide, onSave, alertToEdit }) {
  const { apiData, formData } = useSelector((state) => state.alert);
  const [pageErrorMessage, setPageErrorMessage] = useState("")
  const dispatch = useDispatch()

  useEffect(() => {
    if (alertToEdit !== null) {
      dispatch({
        type: SET_FORM_VALUE,
        payload: {
          formField: "alert_type",
          value: alertToEdit.alert_type
        }
      })
      dispatch({
        type: SET_FORM_VALUE,
        payload: {
          formField: "channel_name",
          value: alertToEdit.alert_type.toUpperCase() === "TEAMS" ? JSON.parse(alertToEdit.alert_config).channel_name : ""
        }
      })
      dispatch({
        type: SET_FORM_VALUE,
        payload: {
          formField: "weebhook_link",
          value: alertToEdit.alert_type.toUpperCase() === "TEAMS" ? JSON.parse(alertToEdit.alert_config).webhook_link : ""
        }
      })
      dispatch({
        type: SET_FORM_VALUE,
        payload: {
          formField: "email",
          value: alertToEdit.alert_type.toUpperCase() === "EMAIL" ? JSON.parse(alertToEdit.alert_config).email : ""
        }
      })

      dispatch({
        type: SET_FORM_VALUE,
        payload: {
          formField: "activateAlert",
          value: alertToEdit.is_active
        }
      })
    }
  }, [])

  // function validateEmail(email) {
  //   const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  //   if (!regex.test(email)) {
  //     setErrorMessage("email", "Please enter valid email")
  //   }
  //   return regex.test(email);
  // }
  const setErrorMessage = (fieldname, errorMessage) => {
    dispatch({
      type: SET_ERROR_MESSAGE,
      payload: {
        formField: fieldname,
        isError: true,
        errorMessage: errorMessage
      }
    })
  }
  const closeDialog = () => {
    dispatch({
      type: CLEAR_ALL_ERROR_MESSAGE
    })
    dispatch({
      type: SET_FORM_VALUE,
      payload: {
        formField: "alert_type",
        value: ""
      }
    })
    dispatch({
      type: SET_FORM_VALUE,
      payload: {
        formField: "email",
        value: ""
      }
    })
    dispatch({
      type: SET_FORM_VALUE,
      payload: {
        formField: "channel_name",
        value: ""
      }
    })
    dispatch({
      type: SET_FORM_VALUE,
      payload: {
        formField: "weebhook_link",
        value: ""
      }
    })
    dispatch({
      type: SET_FORM_VALUE,
      payload: {
        formField: "activateAlert",
        value: true
      }
    })
    onHide()
  }
  const duplicateCheck = () => {
    let currentConfig = formData.alert_type.value.toUpperCase() === "EMAIL" ? JSON.stringify({ email: formData.email.value }) : JSON.stringify({ 'channel_name': formData.channel_name.value, 'webhook_link': formData.weebhook_link.value })
    if (apiData.alertList.data.filter((val) => val.alert_config === currentConfig).length > 0) {
      setPageErrorMessage("Duplicate alert found")
      return true
    }
    return false
  }
  return (
    <PopUpScreen
      header={alertToEdit === null ? "Configure New Alert" : "Edit Alert"}
      onHide={closeDialog}
      style={{ width: "38%" }}
    >
      <div className="grid">
        <div className="col-12">
          <FormDropdown
            style={{ width: "100%" }}
            value={formData.alert_type.value}
            options={formData.alert_type.options}
            onChange={(e) => {
              dispatch({
                type: SET_FORM_VALUE,
                payload: {
                  formField: "alert_type",
                  value: e.target.value
                }
              })
            }}
            placeholder="Select Alert Type"
            label="Alert Type"
            required
          />
          <ErrorMessage message={formData.alert_type.errorMessage} />

        </div>

        <div className="col-12" style={{ marginTop: "10px" }}>
          { 
            formData.alert_type.value.toUpperCase() === "EMAIL" ? <Fragment>
              <Forminputtext
                style={{ width: "100%" }}
                value={formData.email.value}
                onChange={(e) => {
                  dispatch({
                    type: SET_FORM_VALUE,
                    payload: {
                      formField: "email",
                      value: e.target.value
                    }
                  })
                }}
                placeholder="abc@example.com,xyz@example.com"
                label="Email"
                required
              />
              <ErrorMessage message={formData.email.errorMessage} />
            </Fragment>
              :
              <div className="grid">
                <div className="col-6">
                  <Forminputtext
                    style={{ width: "100%" }}
                    value={formData.channel_name.value}
                    onChange={(e) => {
                      dispatch({
                        type: SET_FORM_VALUE,
                        payload: {
                          formField: "channel_name",
                          value: e.target.value
                        }
                      })
                    }}
                    placeholder="Enter Channel Name"
                    label="Channel Name"
                    required
                  />
                  <ErrorMessage message={formData.channel_name.errorMessage} />
                </div>
                <div className="col-6">
                  <Forminputtext
                    style={{ width: "100%" }}
                    value={formData.weebhook_link.value}
                    onChange={(e) => {
                      dispatch({
                        type: SET_FORM_VALUE,
                        payload: {
                          formField: "weebhook_link",
                          value: e.target.value
                        }
                      })
                    }}
                    placeholder="Enter Weebhook Link"
                    label="Weebhook Link"
                    required
                  />
                  <ErrorMessage message={formData.weebhook_link.errorMessage} />

                </div>
              </div>
          }
        </div>

        <div className="col-12" style={{ marginTop: "10px" }}>
          <Checkbox
            style={{ color: "green" }}
            checked={formData.activateAlert.value}
            onChange={(e) => {
              dispatch({
                type: SET_FORM_VALUE,
                payload: {
                  formField: "activateAlert",
                  value: e.checked
                }
              })
            }}
            label="Select All"
          />
          <label className="ml-2">Is Active</label>
        </div>

      </div>
      <ErrorMessage message={pageErrorMessage} />

      <div className="grid">
        <div
          className="col-12"
          style={{ marginTop: "20px", textAlign: "right" }}
        >
          <Button
            label="Cancel"
            style={{ width: "130px", marginRight: "10px" }}
            outlined
            onClick={closeDialog}
          />
          <Button
            label="Save"
            style={{ width: "130px", marginRight: "10px" }}
            onClick={() => {
              dispatch({
                type: CLEAR_ALL_ERROR_MESSAGE
              })
              if ( emptyErrorCheck(emptycheckFields.newAlert, formData, setErrorMessage).length === 0) {

           
                if (formData.alert_type.value.toUpperCase() === "EMAIL") {
              
                  if (alertToEdit !== null) {
                    dispatch(EditAlert(alertToEdit.alert_id, dataAssetId))
                    closeDialog()
                  } else {
                    dispatch(submitAlert(dataAssetId))
                    closeDialog()
                  }
                } else {
                  if (alertToEdit !== null) {
                    dispatch(EditAlert(alertToEdit.alert_id, dataAssetId))
                    closeDialog()
                  } else {
                    dispatch(submitAlert(dataAssetId))
                    closeDialog()
                  }
                }


              }
            }}
          />
        </div>
      </div>
    </PopUpScreen>
  );
}

export default AddNewAlert;
